<template>
  <el-aside :width="$store.state.isCollapsed ? '64px' : '240px'">
    <div class="side-brand" :class="{ collapsed: $store.state.isCollapsed }">
      <div class="brand-mark">
        <img src="/favicon.ico" alt="logo" />
      </div>
      <div v-show="!$store.state.isCollapsed" class="brand-copy">
        <strong>AI Agent</strong>
        <span>运营管理后台</span>
      </div>
    </div>
    <el-menu class="side-menu" :collapse="$store.state.isCollapsed" :collapse-transition="false" :router="true"
      :default-active="route.fullPath">
      <el-menu-item index="/index">
        <el-icon><home-filled /></el-icon>
        <span>首页</span>
      </el-menu-item>
      <el-menu-item index="/center">
        <el-icon>
          <data-analysis />
        </el-icon>
        <span>数据统计</span>
      </el-menu-item>
      <el-menu-item index="/addstyle">
        <el-icon>
          <avatar />
        </el-icon>
        <span>添加风格</span>
      </el-menu-item>

      <el-menu-item index="/discover">
        <el-icon>
          <avatar />
        </el-icon>
        <span>发现管理</span>
      </el-menu-item>

      <el-sub-menu index="/user-manage" v-admin>
        <template #title>
          <el-icon>
            <user-filled />
          </el-icon>
          <span>用户管理</span>
        </template>
        <el-menu-item index="/user-manage/userlist">用户列表</el-menu-item>
        <el-menu-item index="/user-vip/OpenVip">VIP与充值</el-menu-item>
      </el-sub-menu>

      <el-sub-menu index="/news-manage">
        <template #title>
          <el-icon>
            <message-box />
          </el-icon>
          <span>用户推广</span>
        </template>
        <el-menu-item index="/news-manage/newslist">推广详情</el-menu-item>
        <el-menu-item index="/news-manage/addnews">提现管理</el-menu-item>
      </el-sub-menu>

      <el-sub-menu index="/modesset">
        <template #title>
          <el-icon>
            <message-box />
          </el-icon>
          <span>模型管理</span>
        </template>
        <el-menu-item index="/modesset">模型设置</el-menu-item>
        <el-menu-item index="/llm-models">大语言模型设置</el-menu-item>
      </el-sub-menu>

      <el-sub-menu index="/brandapply">
        <template #title>
          <el-icon>
            <message-box />
          </el-icon>
          <span>品牌管理</span>
        </template>
        <el-menu-item index="/brandapply">贴牌申请</el-menu-item>
      </el-sub-menu>

      <el-menu-item index="/public-messages" v-admin>
        <el-icon><bell-filled /></el-icon>
        <span>公共消息管理</span>
      </el-menu-item>

    </el-menu>
  </el-aside>
</template>

<script setup>
import { HomeFilled, Avatar, UserFilled, MessageBox, DataAnalysis, BellFilled } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
const route = useRoute();
// console.log()
const store = useStore();
const vAdmin = {
  mounted(el) {
    if (!store.state.userInfo || store.state.userInfo.role !== 1) {
      el.parentNode.removeChild(el);
    }
  },
};
</script>

<style lang="scss" scoped>
.el-aside {
  height: 100vh;
  background: #060D1B;
  border-right: 1px solid rgba(94, 116, 150, 0.14);

  .side-brand {
    height: 76px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
    padding: 0 18px;
    background:
      linear-gradient(135deg, rgba(255, 116, 23, 0.14), transparent 48%),
      #060D1B;
    border-bottom: 1px solid rgba(94, 116, 150, 0.14);
  }

  .side-brand.collapsed {
    justify-content: center;
    padding: 0;
  }

  .brand-mark {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.02em;
    background: linear-gradient(135deg, #ff7417, #7c3aed);
    box-shadow: 0 10px 28px rgba(255, 116, 23, 0.24);

    img {
      width: 22px;
      height: 22px;
      object-fit: contain;
      display: block;
    }
  }

  .brand-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .brand-copy strong {
    color: #ffffff;
    font-size: 17px;
    line-height: 1;
  }

  .brand-copy span {
    color: #8ea0bc;
    font-size: 12px;
  }

  .side-menu {
    background: #060D1B;
    height: calc(100vh - 76px);
  }
}

.el-menu-item {
  color: aliceblue;
}

.el-sub-menu__title {
  color: aliceblue;

  .el-icon {
    color: aliceblue;
  }

  span {
    color: aliceblue;
  }

  .el-sub-menu__icon-arrow {
    color: aliceblue;
  }
}

.el-aside {
  height: 100vh;
  background: #060D1B;

  /* 使用 :deep() 穿透作用域，覆盖 Element Plus 的默认样式 */
  :deep(.side-menu) {
    background: #060D1B;
    border-right: none;
    height: calc(100vh - 76px);
    /* 建议去掉菜单右侧默认的 1px 细线边框，视觉更统一 */

    /* 重新定义 Element Plus 的内部 CSS 变量 */
    --el-menu-bg-color: #060D1B;
    /* 基础背景色 */
    --el-menu-text-color: aliceblue;
    /* 基础文字颜色 */
    --el-menu-hover-bg-color: #1a2332;
    /* 鼠标悬停 & 展开时的背景色 (稍微提亮的深空灰蓝) */
    --el-menu-active-color: #409eff;
    /* 选中时的文字颜色 (这里用了经典的 Element 蓝) */
  }

  /* 可选：让展开的子菜单背景色略微加深一点，增加视觉层次感 */
  :deep(.el-menu--inline) {
    --el-menu-bg-color: #030812;
    height: auto;
  }

  /* 统一处理基础文字和图标的颜色 */
  :deep(.el-menu-item),
  :deep(.el-sub-menu__title) {
    color: var(--el-menu-text-color);

    .el-icon {
      color: inherit;
      /* 让图标颜色自动跟随当前菜单项的文字颜色 */
    }
  }

  /* 处理选中状态，给它加上和悬停一样的底色，并加粗字体 */
  :deep(.el-menu-item.is-active) {
    background-color: var(--el-menu-hover-bg-color);
    font-weight: bold;
  }
}
</style>
